import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Valeur de repli affichée/injectée tant que le live Google n'a pas répondu.
export const FALLBACK_REVIEWS = { rating: 4.9, count: 704 };

let live = null;
let pending = null;

export function getReviewCount() {
  return live ? live.count : FALLBACK_REVIEWS.count;
}

function patchJsonLdReviewCount(count) {
  document.querySelectorAll('script[type="application/ld+json"]').forEach((el) => {
    if (!el.textContent.includes("reviewCount")) return;
    try {
      const data = JSON.parse(el.textContent);
      let changed = false;
      const walk = (node) => {
        if (!node || typeof node !== "object") return;
        if (node["@type"] === "AggregateRating" && node.reviewCount) {
          if (node.reviewCount !== String(count)) {
            node.reviewCount = String(count);
            changed = true;
          }
        }
        Object.values(node).forEach(walk);
      };
      walk(data);
      if (changed) el.textContent = JSON.stringify(data);
    } catch (e) {
      /* JSON-LD non parsable : on n'y touche pas */
    }
  });
}

// Récupère (une seule fois) le nombre d'avis live puis synchronise tous les
// blocs JSON-LD contenant un aggregateRating (y compris celui d'index.html).
export function syncReviewStats() {
  if (live) {
    patchJsonLdReviewCount(live.count);
    return;
  }
  if (!pending) {
    pending = axios
      .get(`${API}/reviews`)
      .then((res) => {
        const r = res.data?.rating;
        const c = res.data?.userRatingCount;
        if (r && c) {
          live = { rating: r, count: c };
          patchJsonLdReviewCount(c);
        }
      })
      .catch(() => {
        pending = null;
      });
  } else {
    pending.then(() => {
      if (live) patchJsonLdReviewCount(live.count);
    });
  }
}
